var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { attrs: { method: "GET", action: "/search" } }, [
    _c("div", { staticClass: "container-max" }, [
      _c("div", { staticClass: "position-relative" }, [
        _c(
          "div",
          { staticClass: "d-flex flex-grow-1 position-relative my-2" },
          [
            _c("input", {
              ref: "searchInput",
              staticClass: "search-input flex-grow-1 px-3 py-2",
              attrs: {
                name: "query",
                type: "search",
                "aria-label": _vm.$translate(
                  "modeherz::SearchClient.searchSearch"
                ),
                role: "presentation",
                autocomplete: "off",
                spellcheck: "false",
              },
              on: {
                keyup: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.prepareSearch()
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "down", 40, $event.key, [
                        "Down",
                        "ArrowDown",
                      ])
                    ) {
                      return null
                    }
                    return _vm.keydown()
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "up", 38, $event.key, [
                        "Up",
                        "ArrowUp",
                      ])
                    ) {
                      return null
                    }
                    return _vm.keyup()
                  },
                ],
                focus: function ($event) {
                  _vm.isSearchFocused = true
                },
                blur: function ($event) {
                  return _vm.setIsSearchFocused(false)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "search-submit px-3",
                attrs: { type: "submit" },
                on: {
                  click: function ($event) {
                    return _vm.search()
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa fal fa-search",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }